module.exports = __webpack_public_path__ + "static/media/ivyachievement.f69702da.png";